<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="card">
  <div class="card-body">
    <div class="row no-gutters">
      <div class="col">
        <h3 class="mb-0">Manage Loading Levels Program relationships</h3>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <form class="form" (ngSubmit)="onSave()" [formGroup]="formGroup" #ngForm="ngForm" novalidate>
          <h3> </h3>
          <ng-container formArrayName="loadingLevels">
            <div *ngFor="let item of formGroup.get('loadingLevels').controls; index as i">
              <ng-container [formGroupName]="i">
                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-control-label" for="name">
                        Loading Level {{item.get('loadingLevel').value}}
                      </label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <programs-dropdown class="form-control" formControlName="programId"></programs-dropdown>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="row form-btns">
            <div class="col-6 text-right">
              <button type="submit" [promiseBtn]="submitComplete" class="btn btn-primary">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>
